import React from 'react'
import { Spin } from 'antd'
import TableRow from './TableRow'
import { canViewStoreName } from '../../../../services/StorageServices'

const IssuesManagementTable = ({ loading, error, listIssues, reload, idSupplier }) => {
    const canViewStore = canViewStoreName()

    const _renderTableContent = () => {
        if (listIssues.length === 0 && !error) {
            return <tr>
                <td colSpan={11}>No data</td>
            </tr>
        }

        if (!!error) {
            return <tr>
                <td colSpan={11} className='text-danger'>{error}</td>
            </tr>
        }

        return listIssues.length > 0 && listIssues.map((item) => {
            return <TableRow
                key={item._id}
                item={item}
                canViewStore={canViewStore}
                reload={reload}
                idSupplier={idSupplier}
            />
        })
    }

    return (
        <div className='IssuesManagementTable SkuTable'>
            <Spin tip="Loading..." spinning={loading}>
                <table className="table table-striped">
                    <thead className="TableHead">
                        <tr>
                            <th className="Barcode">Barcode</th>
                            <th className="BarcodeItem">Barcode item</th>
                            <th className="ProductType">Loại sản phẩm</th>
                            <th className="IssueType">Loại lỗi</th>
                            <th className="Accepted">Lỗi chấp nhận</th>
                            <th className="Note">Note của FFM</th>
                            <th className="Solution">Giải pháp</th>
                            <th className="SupplierConfirm text-center">Kết quả duyệt</th>
                            <th className="SupplierNote">Note của xưởng</th>
                            <th className="User">Người duyệt</th>
                            <th className="Action">Action</th>
                        </tr>
                    </thead>
                    <tbody className="TableBody">
                        {_renderTableContent()}
                    </tbody>
                </table>
            </Spin>
        </div>
    )
}

export default IssuesManagementTable